module.exports = __webpack_public_path__ + "static/img/04.063ae5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/04.jpg
// module id = bzxM
// module chunks = 18